import React from 'react';
import Edit from '../../rest/Edit';
import Form from '../components/Form';

const WorkingTimesEdit = props => (
  <Edit {...props} resource="workingRegisters">
    <Form />
  </Edit>
);

WorkingTimesEdit.propTypes = {};

export default WorkingTimesEdit;
